import type { SupplementStage } from '@/types/supplement';

export const SUPPLEMENT_ARM = {
  CONTROL: 'control',
  A: 'a',
  B: 'b',
} as const;

export const SUPPLEMENT_PLAN = {
  ONE_MONTH: '1-month',
  THREE_MONTHS: '3-months',
} as const;

export const SUPPLEMENT_STAGE = {
  NONE: 'none',
  SKIPPED: 'skipped',
  ADDRESSED: 'addressed',
  OPTED_IN: 'opted-in',
} as const;

export const SUPPLEMENT_SHEET = {
  NONE: 'none',
  ADDRESS: 'address',
  SOLD_OUT: 'sold-out',
  OPTED_IN: 'opted-in',
} as const;

export const SUPPLEMENTS_ROUTE = 'supplements';
export const SUPPLEMENT_OFFER_ROUTE = 'offer';
export const FINAL_PAGE_ROUTE = 'final-page';
export const TIPS_ROUTE = 'tips';

export const ENTERS_FLOW_BY_STAGE: Record<SupplementStage, boolean> = {
  [SUPPLEMENT_STAGE.NONE]: true,
  [SUPPLEMENT_STAGE.SKIPPED]: false,
  [SUPPLEMENT_STAGE.ADDRESSED]: true,
  [SUPPLEMENT_STAGE.OPTED_IN]: true,
};
